<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-600">
          <div class="modal-header">
            <slot name="header">
              Schedule
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div>Select the date range then press Print</div>
              <DatePicker
                mode="range"
                v-model="dates"
                :attributes="attrs"
                :firstDayOfWeek="2"
                color="blue"
                is-inline
              />
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_print_selection">
                Print
              </button>
              <button class="btn btn-plt" @click="_reset">
                Reset dates
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
//import Calendar from "v-calendar/lib/components/calendar.umd";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import { mapState } from "vuex";

export default {
  name: "ReportDatePicker",
  data: () => ({
    dates: [],
  }),
  computed: {
    ...mapState("schedule", ["schedule_group", "schedule_start_date"]),
    attrs() {
      return [
        {
          key: "today",
          highlight: {
            color: "teal",
          },
          dates: new Date(),
        },
      ];
    },
  },
  mounted: function() {
    this.$nextTick(function() {
      this._reset();
    });
  },
  methods: {
    _reset() {
      if (this.schedule_start_date && this.schedule_group) {
        var start = new Date(this.schedule_start_date);
        var end = new Date();
        end.setDate(start.getDate() + this.schedule_group.duration * 7 - 1);
        this.dates = {
          start: start,
          end: end,
        };
      } else {
        this.dates = null;
      }
    },
    _print_selection() {
      this.$emit("print", this.dates);
    },
  },
  components: {
    //    Calendar,
    DatePicker,
  },
};
</script>
